import React, { FC } from 'react';
import { EspacioProteccion, ObraProperties } from '../../../../../types/ObraDetails';
import { ValidationError } from '../../../../../types/ValidationError';
import styles from './protectedSpace.module.scss';
import ProtectedSpaceRow from './protectedSpaceRow/protectedSpaceRow';

interface ProtectedSpaceProps {
  obra: ObraProperties,
  editable: boolean,
  handleDelete?: (i: number) => void,
  errors?: ValidationError[];
}
const ProtectedSpace: FC<ProtectedSpaceProps> = (props) => {
  const { obra, editable } = props;
  const [protectedSpacesRows] = React.useState<EspacioProteccion[]>(obra.localizacion.espacioProteccion || []);

  return <div className={styles.protectedSpaceContainer}>
    {protectedSpacesRows.map((e, i) => {
      return <ProtectedSpaceRow
        key={i}
        space={e}
        editable={editable}
      />;
    })}
  </div>;
};

export default ProtectedSpace;
